var map = {
	"./charles-postiaux-VsGyECexVy4-unsplash.jpg": 880,
	"./dimitry-anikin-M7sdBYlrw9w-unsplash.jpg": 881,
	"./i/undraw_contact_us_15o2.svg": 808,
	"./jessica-guzik-Fuj145tMO84-unsplash.jpg": 882
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 879;